/* global flatpickr */
// todo: get flatpickr via import
import template from './template.html'
import moment from 'moment'

const isInt = (n) => n === parseInt(n)
const rndBy = (r, n) => Math.round(n / r) * r
const rndUpBy = (r, n) => Math.ceil(n / r) * r

// builds a date based on transform, and optional base that defaults to now
function buildDate(transform, base) {
  if (Object.prototype.hasOwnProperty.call(transform, 'date')) {
    return transform.date
  }
  const date = base ? new Date(base) : new Date()
  const xf = transform || {}
  if (isInt(xf.hours)) {
    date.setHours(xf.hours)
  }

  if (isInt(xf.minutes)) {
    date.setMinutes(xf.minutes)
  }

  if (xf.addDays) {
    date.setDate(date.getDate() + xf.addDays)
  }

  if (xf.addHours) {
    date.setHours(date.getHours() + xf.addHours)
  }

  if (xf.addMinutes) {
    date.setMinutes(date.getMinutes() + xf.addMinutes)
  }

  if (isInt(xf.roundMinutesBy) && xf.roundMinutesBy > 0) {
    // round/up minutes by given interval (like 10)
    date.setMinutes(
      xf.roundMinutesUp
        ? rndUpBy(xf.roundMinutesBy, date.getMinutes())
        : rndBy(xf.roundMinutesBy, date.getMinutes())
    )
  }

  date.setSeconds(0)
  date.setMilliseconds(0)

  return date
}

// directive specific
const dayPicks = [
  {
    display: 'Now',
    transform: { addMinutes: 5, roundMinutesBy: 10, roundMinutesUp: true },
  },
]

// closures scope to some functions used in template
// todo: refactor this to general controller init
function addTemplateFunctions(scope) {
  // apply date and time transfomrms to a base time of now
  // empty/unset transforms are noop
  scope.update = function () {
    scope.date = buildDate(scope.dateXf)
    if (scope.pickr) {
      const timezone = window.org_settings.timezone || null
      if (timezone) {
        const validDate = moment(scope.date, timezone)
        scope.date = moment.utc(validDate).format()
        scope.pickr.setDate(validDate.toDate())
      } else {
        scope.pickr.setDate(scope.date)
      }
    }
  }

  // scope.setDate = function (pick) {
  //   scope.date = pick
  // }
  scope.pickDate = function (pick) {
    scope.dateXf = (pick && pick.transform) || null
    scope.update()
  }

  scope.customDate = function ($event) {
    scope.dateXf = null
    scope.pickr.open()
    if ($event) {
      $event.stopPropagation() // event can cause double toggle
    }
  }
}

function directive($rootScope, storyService, timePickerService) {
  return {
    restrict: 'E',
    template,
    replace: true,
    scope: {
      date: '=',
      storyObj: '=',
      label: '@',
      isRequired: '=',
      isRequiredNotify: '=',
    },
    controller: [
      '$scope',
      function ($scope) {
        $scope.dayPicks = dayPicks
        timePickerService.fetchPickers().then(function (timePickers) {
          timePickers = timePickerService.parseDatums('pp', timePickers)
          for (let idx = 0; idx < timePickers.length; idx++) {
            $scope.dayPicks.push({
              display: moment(timePickers[idx]).format('ddd HH:mm'),
              transform: { date: timePickers[idx] },
            })
          }
        })
        $scope.pickr = null
        addTemplateFunctions($scope)

        $rootScope.$on('SAVE_SUCCESS', (evt, data) => {
          $scope.storyObj = data.story
        })
      },
    ],
    link: function (scope, element, attrs) {
      const pickr = element[0].querySelector('.flatpickr')
      scope.pickr = flatpickr(pickr, {
        defaultDate: scope.date, // todo: ~awt: format
        enableTime: true,
        altInput: true,
        altInputClass: 'rounded-left',
        onChange: (selectedDates, dateStr, instance) => {
          const element = scope.pickr.element
          const timezone = window.org_settings.timezone || null

          let date = selectedDates[0]

          if (timezone) {
            // if timezone, convert it to utc, otherwise treate it as utc
            // date is based on the current timezone and then we convert to utc
            const validDate = moment(new Date(element.value), timezone)
            element.value = date = moment.utc(validDate).format()
          }

          scope.storyObj.planning = scope.storyObj.planning || {}
          scope.storyObj.planning.scheduling =
            scope.storyObj.planning.scheduling || {}
          scope.storyObj.planning.scheduling.planned_publish_date = date
          storyService.setStoryProp('planning', scope.storyObj.planning)
        },
      })
    },
  }
}

export default ['$rootScope', 'storyService', 'timePickerService', directive]
